import { BaseAvamaeResponse } from "api";

export enum MFATypes {
  "SMS" = "SMS",
  "Totp" = "Totp",
  "Email" = "Email",
}
export enum VerificationStep {
  "VerifyEmailAddress" = "VerifyEmailAddress",
  "SetNewPassword" = "SetNewPassword",
  "MfaSetup" = "MfaSetup",
  "VerifyMobilePhoneNumber" = "VerifyMobilePhoneNumber",
}

export type RequirementsResponse = BaseAvamaeResponse<{
  enabledMfaChallengeTypes: MFATypes[];
  mobilePhoneNumber: string;
  verificationRequirements: VerificationStep[];
}>;

export type VerifyEmailResponse = BaseAvamaeResponse<{
  bAccountVerified: boolean;
  verificationRequirements: VerificationStep[];
}>;

export type SetPasswordResponse = BaseAvamaeResponse<{
  bAccountVerified: boolean;
  verificationRequirements: VerificationStep[];
}>;
export type MFAChallengeResponse = BaseAvamaeResponse;
export type MFAEnableResponse = BaseAvamaeResponse;
export type MFADisableResponse = BaseAvamaeResponse;
